module.exports = __webpack_public_path__ + "img/spin.df70c0a6.png";